import { api } from "..";

import { PaginatedResponse, QueryProps } from "@/types/Api";
import { PlayerCoupon } from "@/types/ApiResponses/Coupon";

interface QueryParams {
  status?: string;
  state?: string;       
  startDate?: string;
  endDate?: string;
  lang: string;
}

interface PaginationParams {
  page: number;
  pageSize: number;
}
export const getCouponsHistoryPaginated = async (
  props: QueryProps<QueryParams & PaginationParams>
): Promise<PaginatedResponse<PlayerCoupon[]>> => {
  const res = await api.client.get("/coupon-new/history", {   
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
